/**
 * Identitatea unei „pagini” pentru agent și configurator: pathname + hash.
 * Hash-ul acoperă SPA-urile cu hash-routing (#/rapoarte); query-ul e lăsat
 * deliberat afară - conține filtre/tokenuri volatile care ar fragmenta
 * aceeași pagină în intrări diferite. Aplicațiile care nu reflectă deloc
 * navigarea în URL rămân o limitare documentată (o singură „pagină”).
 */
export function currentPagePath(): string {
  return location.pathname + location.hash;
}
